import React from 'react';

import AddWizardPage from '@qality/common-pages/src/AddTestCasesWizardPage';
import { StorageOfUniqueServices } from '@qality/common-service';

import { AddTestCasesPageStyled } from './AddTestCases.styled';

export default function AddTestCases(): JSX.Element {
  StorageOfUniqueServices.get('AP').sizeToParent(true);
  return (
    <AddTestCasesPageStyled>
      <AddWizardPage />
    </AddTestCasesPageStyled>
  );
}
